import {_extractDOMElemData, updateLinkViewMore, suppresResult, updateTabSelection} from './utils';
import {LOADER_HTML} from "./utils";
import {getTickerInfo,fetchData, unmaskpath, utmsToQueryString} from '../modulesUtils';
import {customCotFormat, number_format} from '../../streaming/utils';
import {EInterceptionObserver} from "../EIntersectionObserver/EIntersectionObserver";

let StreamingProvider = null;
let Utms = null;

String.prototype.trunc =
    function (n, useWordBoundary) {
        var isTooLong = this.length > n,
            s_ = isTooLong ? this.substr(0, n - 1) : this;
        s_ = (useWordBoundary && isTooLong) ? s_.substr(0, s_.lastIndexOf(' ')) : s_;
        return isTooLong ? s_ + '&hellip;' : s_;
    };

/**
 * Inicializa la construcción y dinamización de tablas.
 * Al cargar el DOM, buscará los elementos que encajen con las clases predefinidas por twig.
 * Por cada clase que encuentre, cargará los dinamismos típicos para ese tipo de módulo topbottom
 */
export const initTopBottom = (streamingModule, utms) => {
    StreamingProvider = streamingModule;
    Utms = utms;

    const items = document.querySelectorAll(
        'div.topbottombox-favorites, div.topbottomnav>a:nth-child(1), div.topbottombarforex' +
        ',div.topbottombarlastvisited, div.topbottombarcommodities'
    );

    $('div.topbottomnav>a').click(function(e){
        //Evitamos el evento click de las pestañas para que redirija a la url apuntada por href
        e.preventDefault();
        //Cargamos el módulo
        loadTopBottomBox($(this));
    });

    EInterceptionObserver(items, (target) => {
        let jQueryElem = $(target);
        //Si el elemento que pasa a ser visible son los favoritos, enviar el botón.
        if (jQueryElem.hasClass('topbottombox-favorites')) {
            jQueryElem = jQueryElem.find('a.tab.active');
        }

        loadTopBottomBox(jQueryElem);
    });
};

/**
 * Dependiendo del tipo de búsqueda que esté realizando el módulo,
 * orientará la construcción de la tabla y preparará los dinamismos.
 * @param {Object} $elem Selector JQuery que ha encajado con un tipo de tabla
 * @return {*}
 */
function loadTopBottomBox($elem){
    const elemInfo = _extractDOMElemData($elem);

    switch(elemInfo.search){
        case 'highvol':
        case 'top':
        case 'bottom':
        case 'suppres':
        case 'forex':
        case 'tradingMachineTop':
        case 'tradingMachineBottom':
            return prepareTopBottomVolumeSuppres($elem, elemInfo);
        case 'commodities':
            return prepareCommodities($elem, elemInfo);
        case 'lastvisited':
            return prepareLastVisited($elem, elemInfo);
        case 'favorites':
            return prepareFavorites($elem, elemInfo);
        case 'funds':
            return prepareFunds($elem, elemInfo);
        case 'dividends':
            return prepareDividends($elem, elemInfo);
        default:
            throw 'Unknown topbottom module';
    }
}


/**
 * A partir de la información recibida, prepara la cadena de consulta al server y pinta la tabla
 * @param {Object} $elem Selector JQuery
 * @param {Object} info Información extraída del selector
 */
function prepareTopBottomVolumeSuppres($elem, info)
{
    let url = info.url;
    if(info.search === 'suppres') {
        url += '##cotizaciones-top-bottom##' + 'suppres' + '##' + info.qty + '##' + info.type + '##' + info.id;
    } else if (info.search === 'forex') {
        url += '##cotizaciones-top-bottom##' + info.type + '##0##' + info.type + '##0';
    } else if (info.search === 'tradingMachineTop' || info.search === 'tradingMachineBottom') {
        url += '##cotizaciones-top-bottom-trading-machine##'+info.search+'##'+info.qty+'##'+info.type+'##'+info.id;
    } else {
        url += '##cotizaciones-top-bottom##'+info.search+'##'+info.qty+'##'+info.type+'##'+info.id;
    }

    const newUrl = {name: $elem.prop('title'), url: $elem.data('elementurl') + utmsToQueryString(Utms)};
    const $parent = $elem.parent().parent();
    const $viewMoreLink = $parent.find('.lnk-more');
    const $resultDiv = $parent.find('div.topbottombox-result');
    $resultDiv.html(LOADER_HTML);

    fetchData(url)
        .then(data => {
            switch(info.search){
                case 'top':
                case 'bottom':
                    displayTopBottom($resultDiv, info, data); break;
                case 'highvol':
                    displayHighVol($resultDiv, info, data); break;
                case 'suppres':
                    updateLinkViewMore($viewMoreLink, newUrl);
                    if(data.length > 0)
                        return displaySuppres($resultDiv, info, data);
                    else{
                        return $resultDiv.html('<p class="brief">NO SE HA SUPERADO NINGÚN SOPORTE O RESISTENCIA DURANTE LA JORNADA</p>');
                    }
                    break;
                case 'forex':
                    displayForex($resultDiv, info, data);
                    break;
                case 'tradingMachineTop':
                case 'tradingMachineBottom':
                    //if (data.hasOwnProperty('is_authorize') && data.is_authorize === false) {
                    //    displayTradingMachineNoPremium($resultDiv, info, data);
                    //} else {
                    displayTradingMachine($resultDiv, info, data);
                    //}
                    setTimeout(function () {
                        $('[class^=momento-total-]').addClass('ready');
                    }, 500);
                    break;
                default:
                    throw 'Invalid search type on top bottom';
            }
            updateTabSelection($elem);
            updateLinkViewMore($viewMoreLink, newUrl);
        })
        .catch(()=> $elem.html('<p class="brief">Hubo un problema al obtener la información de cotizaciones</p>'))

}

function prepareCommodities($elem, info)
{
    const url = info['url'] + '##cotizaciones-top-bottom##'+'commodities'+'##'+'0'+'##'+'commodities'+'##'+'0';
    fetchData(url)
        .then(data => displayCommodities($elem, info, data) )
        .catch(() => $elem.html('<p class="brief">Hubo un problema al obtener la información de materias primas</p>'));
}

function prepareLastVisited($elem, info)
{
    let url = info['url'] + '##cotizaciones-marquee';
    if( $elem.data('instrument') ) url += '?id=' + $elem.data('instrument');

    fetchData(url)
        .then(data => {
            if(Array.isArray(data) && data.length > 0)
                return displayLastVisited($elem, info, data);
            else
                $elem.html('<p class="brief">No ha visitado cotizaciones todavía. Aquí se mostrarán las cotizaciones que visite</p>');
        })
        .catch(() => $elem.html('<p class="brief">Hubo un problema al obtener la información de últimos visitados</p>'));
}

/**
 * Obtiene del servidor la respuesta JSON de favoritos. Después, en base a si está registrado o no tomará una determinación.
 * Si está registrado, mostrará su lista de favoritos o un mensaje indicándole que todavía no tiene favoritos.
 * Si no, mostrará los últimos visitados o un mensaje de que no ha visitado ninguna cotización
 * @param $elem
 * @param info
 */
function prepareFavorites($elem, info)
{
    const tab = $elem.data('elementtab');
    const $parent = $elem.parent().parent();
    const $resultDiv = $parent.find('div.topbottombox-result');
    const url = info.url + '##cotizaciones-favoritos##'+tab+'##'+info.qty;

    $resultDiv.html(LOADER_HTML);

    fetchData(url)
        .then(data => {
            if(data.hasOwnProperty('is_logged') && data.is_logged === true){
                //Está registrado
                if(data.hasOwnProperty('nodata')){
                    return $resultDiv.html('<p class="brief">Su lista de favoritos está vacía</p>');
                }else{
                    //$parent.parent().find('.headband span').text('Favoritos');
                    $parent.find('div').show();
                    return displayFavorites($resultDiv, info, data.data);
                }
            }else{
                if(Array.isArray(data) && data.length){
                    $parent.parent().find('.headband span').text('Últimos visitados');
                    $parent.find('div.m-title.topbottomnav').remove();
                    $parent.find('div').show();
                    return displayLastVisited($resultDiv, info, data);
                }else{
                    // generamos la cookie sino se ha generado
                    $parent.parent().find('.headband span').text('Últimos visitados');
                    return $resultDiv.html('<p class="brief">No ha visitado cotizaciones todavía. Aquí se mostrarán las cotizaciones que visite</p>');
                }
            }
        })
        .catch(() => $resultDiv.html('<p class="brief">Hubo un problema al obtener la información de favoritos</p>'));
}

function prepareFunds($elem, info)
{
    const zone = $elem.data('zone') ? '##'+$elem.data('zone') : '';
    let url = info['url'] + zone;
    const $parent = $elem.parent().parent();
    const $resultDiv = $parent.find('div.topbottombox-result');
    $resultDiv.html(LOADER_HTML);

    fetchData(url)
        .then(data => displayFunds($resultDiv, info, data))
        .catch(() => $elem.html('<p class="brief">Hubo un problema al obtener la información de fondos</p>'));
}

function prepareDividends($elem, info)
{
    const url = info.url + '##cotizaciones-top-bottom##' + 'dividends' + '##' + info.qty ;
    const showAll = $elem.siblings('.module-lnk-more').find('a.show-all');
    showAll.click(function(e) {
        e.preventDefault();

        $(this).remove();
        const altUrl = info.url + '##cotizaciones-top-bottom##' + 'dividends' ;
        $elem.html(LOADER_HTML);
        fetchData(altUrl)
            .then(data => displayDividendos($elem, info, data) )
            .catch(() => $elem.html('<p class="brief">Hubo un problema al obtener la información de dividendos</p>'));
    });

    fetchData(url)
        .then(data => displayDividendos($elem, info, data) )
        .catch(() => $elem.html('<p class="brief">Hubo un problema al obtener la información de dividendos</p>'));
}

/**
 * Pinta la tabla de materias primas
 * @param {Object} $elem Selector JQuery que contendrá la tabla
 * @param {Object} infoBase Datos extraidos del selector sobre la búsqueda
 * @param {Object} data Información JSON obtenida del servidor
 */
function displayCommodities($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Materia</th><th>Precio</th><th>Variación</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        let tickersIds = [];
        const urlBase = infoBase['url'];
        for(let ticker of data){
            const info = getTickerInfo(ticker);
            tickersIds.push(info.tickerId);
            const name = '<a class="lnk" href="'+unmaskpath(urlBase)+info.uriLink+utmsToQueryString(Utms)+'" title="Ver ficha de '+info.name+'">'+info.name.trunc(20, true)+'</a>';
            const $tr = $('<tr></tr>');

            $tr.append('<td scope="row">'+name+'</td>' +
                '<td class="last-'+info.tickerId+'" data-value="'+info.last+'" data-decimal="4">'+info.lastStr+'</td>' +
                '<td class="'+info.varperClass+' varPerc-'+info.tickerId+'" data-value="'+info.varperc+'" data-decimal="2"">'+info.varpercStr+'</td>');
            $body.append($tr);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);

        subscribeToTickerWebSocket(tickersIds);

    }catch(ex){
        console.error(ex);
        throw ex;
    }

}

/**
 * Pinta la tabla de forex
 * @param {Object} $elem Selector JQuery que contendrá la tabla
 * @param {Object} infoBase Datos extraidos del selector sobre la búsqueda
 * @param {Object} data Información JSON obtenida del servidor
 */
function displayForex($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Divisa</th><th>Cambio</th><th>Variación</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        let tickersIds = [];
        const urlBase = infoBase['url'];
        const base_url_statics = $elem.data('base-url-statics') || 'https://www.estrategiasdeinversion.com/';

        for(let ticker of data){
            const info = getTickerInfo(ticker);
            tickersIds.push(info.tickerId);

            const $tr = $('<tr></tr>');

            if (infoBase.type == 'forex') {
                const flag1 = base_url_statics+'iconos/'+ticker['flag1']+'.png';
                const flag2 = base_url_statics+'iconos/'+ticker['flag2']+'.png';

                const name = '<a class="lnk" href="'+unmaskpath(urlBase)+info.uriLink+utmsToQueryString(Utms)+'" title="Ver ficha de '+info.name+'"><img src="'+flag1+'"> <img src="'+flag2+'"> '+info.name.trunc(20, true)+'</a>';
                $tr.append('<td scope="row">'+name+'</td>' +
                    '<td class="last-'+info.tickerId+'" data-value="'+info.last+'" data-decimal="4">'+info.lastStr+'</td>' +
                    '<td class="'+info.varperClass+' varPerc-'+info.tickerId+'" data-value="'+info.varperc+'" data-decimal="2"">'+info.varpercStr+'</td>');
            }
            else {
                const name = '<a class="lnk" href="'+unmaskpath(urlBase)+info.uriLink+utmsToQueryString(Utms)+'" title="Ver ficha de '+info.name+'"> '+info.name.trunc(20, true)+'</a>';
                $tr.append('<td scope="row">'+name+'</td>' +
                    '<td class="last-'+info.tickerId+'" data-value="'+info.last+'" data-decimal="4">'+info.lastStr+'</td>' +
                    '<td class="'+info.varperClass+' varPerc-'+info.tickerId+'" data-value="'+info.varperc+'" data-decimal="2"">'+info.varpercStr+'</td>');
            }


            $body.append($tr);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);

        subscribeToTickerWebSocket(tickersIds);

    }catch(ex){
        console.error(ex);
        throw ex;
    }

}

function displayLastVisited($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Valor</th><th>Precio</th><th>Variación</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        const urlBase = infoBase['url'];

        for(let ticker of data){
            const info = getTickerInfo(ticker);
            const url = unmaskpath(urlBase) + info.uriLink;
            const $tr = $('<tr></tr>');
            const name = '<a href="'+url+'" class="lnk" title="Ver ficha de '+info.name+'">'+info.name.trunc(20, true)+'</a>';

            $tr.append('<td scope="row">'+name+'</td>' +
                '<td class="last-'+info.tickerId+'" data-value="'+info.last+'" data-decimal="3">'+info.lastStr+'</td>' +
                '<td class="'+info.varperClass+' varPerc-'+info.tickerId+'" data-value="'+info.varperc+'" data-decimal="2"">'+info.varpercStr+'</td>');
            $body.append($tr);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

function displayFavorites($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Valor</th><th>Precio</th><th>Variación</th><th></th></tr></thead>');
        const $body = $('<tbody></tbody>');
        const urlBase = infoBase['url'];
        var idTickerForWS = [];

        for(let ticker of data){
            const info = getTickerInfo(ticker);
            const url = unmaskpath(urlBase) + info.uriLink;
            const tab = ticker.tab;
            const $tr = $('<tr></tr>');
            const name = '<a href="'+url+'" class="lnk" title="Ver ficha de '+info.name+'">'+info.name.trunc(20, true)+'</a>';

            $tr.append('<td scope="row">'+name+'</td>' +
                '<td class="last-'+info.tickerId+'" data-value="'+info.last+'" data-decimal="3">'+info.lastStr+'</td>' +
                '<td class="'+info.varperClass+' varPerc-'+info.tickerId+'" data-value="'+info.varperc+'" data-decimal="2"">'+info.varpercStr+'</td>' +
                '<td><a rel="nofollow" class="lnk delete-favorite" href="#" title="Eliminar '+info.name+' de esta lista' +
                    ' de favoritos" data-href="'+urlBase+'/favoritos/delete/'+info.tickerId+'/'+tab+'"></a></td>');
            $body.append($tr);
            // creamos un array de tickerId para enviar al ws
            idTickerForWS.push(info.tickerId);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);
        // llamada al WS
       subscribeToTickerWebSocket(idTickerForWS);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

/**
 * Conecta el websocket para los componentes del mercado continuo (siempre) y con los ticker
 * sueltos que no pertenecen a este mercado (forex, commodities).
 * @param {Array} ids idTickers de los elementos devueltos.
 */
function subscribeToTickerWebSocket(ids)
{
    if(StreamingProvider && ids && Array.isArray(ids) && ids.length)
        StreamingProvider.subscribeTickerIDS(ids);
}

function displayTopBottom($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Valor</th><th>Precio</th><th>Variación</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        const urlBase = infoBase['url'];
        let tickersIds = [];

        for(let ticker of data){
            const info = getTickerInfo(ticker);
            const url = unmaskpath(urlBase) + info.uriLink + utmsToQueryString(Utms);
            const name = '<a href="'+url+'" class="lnk" title="Ver ficha de '+info.name+'">'+info.name.trunc(20, true)+'</a>';
            tickersIds.push(info.tickerId);
            const $tr = $('<tr></tr>');

            $tr.append('<td scope="row">'+name+'</td>' +
                '<td class="last-'+info.tickerId+'" data-value="'+info.last+'" data-decimal="4">'+info.lastStr+'</td>' +
                '<td class="'+info.varperClass+' varPerc-'+info.tickerId+'" data-value="'+info.varperc+'" data-decimal="2"">'+info.varpercStr+'</td>');
            $body.append($tr);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);

        subscribeToTickerWebSocket(tickersIds);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

/**
 * Pinta la tabla de máquina de trading
 * @param {Object} $elem Selector JQuery que contendrá la tabla
 * @param {Object} infoBase Datos extraidos del selector sobre la búsqueda
 * @param {Object} data Información JSON obtenida del servidor
 */
function displayTradingMachine($elem, infoBase, data)
{

    try{
        const $header = $('<thead><tr><th>Valor</th><th>Momento total</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        const urlBase = infoBase['url'];
        const dummyData = (data.hasOwnProperty(1) && data[1].hasOwnProperty('dummy_data') && data[1].dummy_data === true) ? 'style="filter: blur(2px);"' : '';
        const filterBlur = (dummyData) ? 'style="filter: blur(2px);"' : '';
        for(let ticker of data[0]){
            const info = getTickerInfo(ticker);
            const url = unmaskpath(urlBase) + '/premium/zona-de-trading/maquina-de-trading/mercado-continuo/' + ticker.slug;
            const title = (dummyData) ? '' : 'Ver ficha de '+info.name+' en la Máquina de Trading';
            const name = '<a href="'+url+'" class="lnk" title="'+title+'">'+info.name.trunc(23, true)+'</a>';
            const $tr = $('<tr></tr>');
            var momentoTotalCssBack = '';
            if (ticker.momento_total == 6) momentoTotalCssBack = 'highGreen';
            if (ticker.momento_total == -6) momentoTotalCssBack = 'highRed';
            $tr.append('<td scope="row">'+name+'</td>' +
                '<td><div class="momento-total-'+ticker.momento_total+' '+momentoTotalCssBack+'"></div></td>');
            $body.append($tr);
        }
        //const filterBlur = (data.hasOwnProperty(1) && data[1].hasOwnProperty('dummy_data') && data[1].dummy_data === true) ? 'style="filter: blur(2px);"' : '';
        const $table = $('<table class="tbl tbl-compact tbl-flat tbl-cn-2" cellspacing="0" width="100%" '+filterBlur+'></table>').append($header);
        $table.append($body);
        $elem.html($table);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

function displayHighVol($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Valor</th><th>Volumen</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        const urlBase = infoBase['url'];
        let tickersIds = [];

        for(let ticker of data){
            const info = getTickerInfo(ticker);
            const url = unmaskpath(urlBase) + info.uriLink + utmsToQueryString(Utms);
            tickersIds.push(info.tickerId)
            const name = '<a href="'+url+'" class="lnk" title="Ver ficha de '+info.name+'">'+info.name.trunc(20, true)+'</a>';
            const $tr = $('<tr></tr>');
            $tr.append('<td scope="row">'+name+'</td>' +
                '<td class="vol-'+info.tickerId+'" data-value="'+info.vol+'">'+info.volStr+'</td>');
            $body.append($tr);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);

        subscribeToTickerWebSocket(tickersIds);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

function displaySuppres($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Valor</th><th>Estado</th><th>Hora</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        const urlBase = infoBase['url'];
        for(let ticker of data){
            const info = getTickerInfo(ticker);
            const url = unmaskpath(urlBase) + info.uriLink + utmsToQueryString(Utms);
            const name = '<a class="lnk" href="' + url + '" title="Ver ficha de '+info.name+'">' + info.name.trunc(20, true) + '</a>';
            const $tr = $('<tr></tr>');

            const suppresHtml = suppresResult(ticker.alert, ticker.timestamp);
            $tr.append('<td scope="row">'+name+'</td>' +
                '<td>'+suppresHtml[0]+'</td>',
                '<td title="'+suppresHtml[1]+'">'+suppresHtml[2]+'</td>');
            $body.append($tr);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}
function displayFunds($elem, infoBase, data)
{
    try{
        const $body = $('<tbody></tbody>');
        //const urlBase = 'https://fondos.estrategiasdeinversion.com/fondos/';

        for(let ticker of data){
            //const url = urlBase + ticker.id + utmsToQueryString(Utms);
            //const name = '<a class="lnk" href="' + url + '" title="Ver ficha de '+ticker.name+'">' + ticker.name.trunc(30, true) + '</a>';
            const name = ticker.name.trunc(30, true);
            const $tr = $('<tr></tr>');

            const performanceFloat = (typeof ticker.performance !== 'number') ? parseFloat(ticker.performance) : ticker.performance;
            const perfomanceClass = (performanceFloat > 0) ? 'valueUp' : 'valueDown';
            const perfomance = number_format(performanceFloat,2,',','.');

            $tr.append('<td scope="row">'+name+'</td>');
            $tr.append('<td class="'+perfomanceClass+'">'+ perfomance+'%</td>');
            $body.append($tr);
        }

        const $header = $('<thead><tr><th>Fondo</th><th>Rend. 12M</th></tr></thead>');
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}
/**
 * Pinta la tabla de dividendos
 * @param {Object} $elem Selector JQuery que contendrá la tabla
 * @param {Object} infoBase Datos extraidos del selector sobre la búsqueda
 * @param {Object} data Información JSON obtenida del servidor
 */
function displayDividendos($elem, infoBase, data)
{
    try{
        const $header = $('<thead><tr><th>Acción</th><th>Ejercicio</th><th>Rentabilidad</th></tr></thead>');
        const $body = $('<tbody></tbody>');
        const urlBase = infoBase['url'];
        for(let item of data){
            const name = '<a class="lnk" href="'+unmaskpath(urlBase)+'/cotizaciones/dividendos/'+item.slug+utmsToQueryString(Utms)+'" title="Ver dividendos de '+item.name+'">'+item.name.trunc(20, true)+'</a>';
            const $tr = $('<tr></tr>');

            $tr.append('<td scope="row">'+name+'</td>' +
                '<td>'+item.year+'</td>' +
                '<td>'+customCotFormat('varPerc', item.yield, 2)+'</td>');
            $body.append($tr);
        }
        const $table = $('<table class="tbl tbl-compact tbl-flat" cellspacing="0" width="100%"></table>').append($header);
        $table.append($body);
        $elem.html($table);
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}
